var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-button', _vm._b({ attrs: { "loading": _vm.loading, "icon": "el-icon-fa-download", "type": "primary" }, on: { "click": _vm.handleClick } }, 'el-button', _vm.innerParams, false), [_vm._v(_vm._s(_vm.label) + "\n")]);
};
var staticRenderFns = [];

export { render, staticRenderFns };